/**
 * Tive API
 *
 * Contact: support@tive.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { Alert } from '../model/alert';
// @ts-ignore
import { AlertCounterNew } from '../model/alertCounterNew';
// @ts-ignore
import { AlertListLengthResult } from '../model/alertListLengthResult';
// @ts-ignore
import { AlertSummary } from '../model/alertSummary';
// @ts-ignore
import { AlertTrigger } from '../model/alertTrigger';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsAlertsService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Retrieves an alert by its unique identifier for the current user and account. (Role Permissions Required: AlertsView)
   * @endpoint get /api/shipments/alert
   * @param alertId The unique identifier of the alert to be retrieved.
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsAlertGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsAlertGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsAlertGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'alertId',
      <any>alertId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alert`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Use this method to get alert summary for the shipment
   * @endpoint get /api/shipments/alertSummary/{internalShipmentId}
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertSummaryInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<AlertSummary>>;
  public apiShipmentsAlertSummaryInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<AlertSummary>>>;
  public apiShipmentsAlertSummaryInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<AlertSummary>>>;
  public apiShipmentsAlertSummaryInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (internalShipmentId === null || internalShipmentId === undefined) {
      throw new Error(
        'Required parameter internalShipmentId was null or undefined when calling apiShipmentsAlertSummaryInternalShipmentIdGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alertSummary/${this.configuration.encodeParam({ name: 'internalShipmentId', value: internalShipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AlertSummary>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Use this method to get alert counters for the shipment
   * @endpoint get /api/shipments/alertcounters
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertcountersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<AlertCounterNew>>;
  public apiShipmentsAlertcountersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<AlertCounterNew>>>;
  public apiShipmentsAlertcountersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<AlertCounterNew>>>;
  public apiShipmentsAlertcountersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alertcounters`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AlertCounterNew>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Use this method to get all alert details (Role Permissions Required: AlertsView)
   * @endpoint get /api/shipments/alertdetails
   * @param alertId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertdetailsGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsAlertdetailsGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsAlertdetailsGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsAlertdetailsGet(
    alertId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'alertId',
      <any>alertId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alertdetails`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Use this method to get alerts per shipment
   * @endpoint get /api/shipments/alerts
   * @param internalShipmentId
   * @param start
   * @param end
   * @param page
   * @param pageSize
   * @param desc
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertsGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Alert>>;
  public apiShipmentsAlertsGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Alert>>>;
  public apiShipmentsAlertsGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Alert>>>;
  public apiShipmentsAlertsGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'start',
      <any>start,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'end',
      <any>end,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'page',
      <any>page,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'desc',
      <any>desc,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alerts`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Alert>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Returns if shipment has unread alerts
   * @endpoint get /api/shipments/alerts/{internalShipmentId}/hasUnreadAlert
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertsInternalShipmentIdHasUnreadAlertGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiShipmentsAlertsInternalShipmentIdHasUnreadAlertGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiShipmentsAlertsInternalShipmentIdHasUnreadAlertGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiShipmentsAlertsInternalShipmentIdHasUnreadAlertGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (internalShipmentId === null || internalShipmentId === undefined) {
      throw new Error(
        'Required parameter internalShipmentId was null or undefined when calling apiShipmentsAlertsInternalShipmentIdHasUnreadAlertGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alerts/${this.configuration.encodeParam({ name: 'internalShipmentId', value: internalShipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/hasUnreadAlert`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Use this method to get alerts per shipment with pagination
   * @endpoint get /api/shipments/alertsPaged
   * @param internalShipmentId
   * @param start
   * @param end
   * @param page
   * @param pageSize
   * @param desc
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertsPagedGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<AlertListLengthResult>;
  public apiShipmentsAlertsPagedGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<AlertListLengthResult>>;
  public apiShipmentsAlertsPagedGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<AlertListLengthResult>>;
  public apiShipmentsAlertsPagedGet(
    internalShipmentId?: string,
    start?: string,
    end?: string,
    page?: number,
    pageSize?: number,
    desc?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'start',
      <any>start,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'end',
      <any>end,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'page',
      <any>page,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'desc',
      <any>desc,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alertsPaged`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AlertListLengthResult>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Use this method to read an alert (make readable) (Role Permissions Required: AlertsView)
   * @endpoint put /api/shipments/alerts
   * @param alertId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertsPut(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsAlertsPut(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsAlertsPut(
    alertId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsAlertsPut(
    alertId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'alertId',
      <any>alertId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alerts`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets alerts specific to a device in shipment
   * @endpoint get /api/shipments/deviceAlerts
   * @param internalShipmentId
   * @param deviceId
   * @param start
   * @param end
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsDeviceAlertsGet(
    internalShipmentId?: string,
    deviceId?: string,
    start?: string,
    end?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Alert>>;
  public apiShipmentsDeviceAlertsGet(
    internalShipmentId?: string,
    deviceId?: string,
    start?: string,
    end?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Alert>>>;
  public apiShipmentsDeviceAlertsGet(
    internalShipmentId?: string,
    deviceId?: string,
    start?: string,
    end?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Alert>>>;
  public apiShipmentsDeviceAlertsGet(
    internalShipmentId?: string,
    deviceId?: string,
    start?: string,
    end?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'deviceId',
      <any>deviceId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'start',
      <any>start,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'end',
      <any>end,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/deviceAlerts`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Alert>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets all current shipment alert triggers that a user can see for the given shipment
   * @endpoint get /api/shipments/shipmentAlertTriggers
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentAlertTriggersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<AlertTrigger>>;
  public apiShipmentsShipmentAlertTriggersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<AlertTrigger>>>;
  public apiShipmentsShipmentAlertTriggersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<AlertTrigger>>>;
  public apiShipmentsShipmentAlertTriggersGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipmentAlertTriggers`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AlertTrigger>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
